import { object, number, array } from '@gogame/schemas';

import { APP_ID, PERIOD, DEFAULT_APP } from '../constants';

export const downloadSchema = object({
  [APP_ID]: array(number()).required('Application is required'),
  [PERIOD]: array().required('Period is required'),
}).default({
  [APP_ID]: [DEFAULT_APP],
});
